import { render, staticRenderFns } from "./VesselPrintTurboChargerPieChart.vue?vue&type=template&id=22f12ea2&scoped=true&"
import script from "./VesselPrintTurboChargerPieChart.vue?vue&type=script&lang=js&"
export * from "./VesselPrintTurboChargerPieChart.vue?vue&type=script&lang=js&"
import style0 from "./VesselPrintTurboChargerPieChart.vue?vue&type=style&index=0&id=22f12ea2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f12ea2",
  null
  
)

export default component.exports